import {InjectionToken} from "@angular/core";
import {IAppService} from "./i-app.service";

export const appServiceInjectionToken: InjectionToken<IAppService> = new InjectionToken<IAppService>("digital-signage.developer-dashboard.AppService");
